import type { Translations } from '../../types'

const ordersMessages: Translations = {
  "orders.auth.title": "Sessione non disponibile",
  "orders.auth.subtitle": "Effettua il login per consultare gli ordini.",
  "orders.auth.missingToken": "Token amministratore mancante.",
  "orders.filters.customerQuery": "Cliente (nome, cognome, email)",
  "orders.filters.customerQueryPlaceholder": "Es. mario.rossi@email.it",
  "orders.filters.status": "Stato ordine",
  "orders.filters.limit": "Limite risultati",
  "orders.status.all": "Tutti gli stati",
  "orders.status.created": "Creato",
  "orders.status.paid": "Pagato",
  "orders.status.shipped": "Spedito",
  "orders.status.cancelled": "Annullato",
  "orders.detailActions.markAsPaid": "Segna come pagato",
  "orders.detailActions.updateStatus": "Applica stato interno",
  "orders.detailActions.setShipped": "Imposta stato: spedito",
  "orders.detailActions.contactCustomer": "Contatta cliente",
  "orders.detailActions.copyOrderNumber": "Copia numero ordine",
  "orders.payment.paid": "Pagato",
  "orders.payment.pending": "In attesa",
  "orders.payment.failed": "Fallito",
  "orders.payment.refunded": "Rimborsato",
  "orders.actions.apply": "Applica",
  "orders.actions.reset": "Reset",
  "orders.actions.updateStatus": "Aggiorna stato",
  "orders.actions.saving": "Salvataggio...",
  "orders.actions.uploadInvoice": "Carica fattura e notifica cliente",
  "orders.actions.uploading": "Upload in corso...",
  "orders.actions.open": "Apri",
  "orders.actions.opening": "Apro...",
  "orders.actions.resendNotification": "Reinvia notifica",
  "orders.actions.resending": "Invio...",
  "orders.actions.cancelInvoice": "Annulla fattura",
  "orders.actions.cancelOrderLine": "Annulla riga",
  "orders.actions.cancelling": "Annullamento...",
  "orders.actions.restoreInvoice": "Revoca annullamento",
  "orders.actions.restoringInvoice": "Ripristino...",
  "orders.actions.modalCancel": "Annulla",
  "orders.actions.modalConfirmOpen": "Conferma apertura",
  "orders.actions.modalConfirmResend": "Conferma reinvio",
  "orders.actions.modalConfirmCancelInvoice": "Conferma annullamento",
  "orders.actions.modalConfirmRestore": "Conferma revoca",
  "orders.actions.backToList": "Torna alla lista ordini",
  "orders.actions.clearSelectedFile": "Rimuovi file selezionato",
  "orders.dashboard.eyebrow": "Operazioni",
  "orders.dashboard.title": "Ordini",
  "orders.dashboard.subtitle": "Panoramica operativa degli ordini e delle azioni disponibili.",
  "orders.bulk.selectedCountSingular": "{{count}} selezionato",
  "orders.bulk.selectedCountPlural": "{{count}} selezionati",
  "orders.bulk.internalStatusHint": "Le azioni aggiornano solo lo stato interno dell'ordine e non eseguono operazioni Stripe.",
  "orders.bulk.settingStatus": "Aggiornamento stato...",
  "orders.bulk.setStatusPaid": "Segna come pagato",
  "orders.bulk.setStatusCancelled": "Annulla ordine",
  "orders.bulk.exportCsv": "Esporta CSV",
  "orders.bulk.clearSelection": "Deseleziona",
  "orders.csvHeaders.orderId": "ID ordine",
  "orders.csvHeaders.orderNumber": "Numero ordine",
  "orders.csvHeaders.customer": "Cliente",
  "orders.csvHeaders.email": "Email",
  "orders.csvHeaders.status": "Stato",
  "orders.csvHeaders.total": "Totale",
  "orders.csvHeaders.currency": "Valuta",
  "orders.csvHeaders.createdAt": "Creato il",
  "orders.navigation.viewing": "Dettaglio ordine",
  "orders.navigation.viewingOrder": "Dettaglio ordine {{orderNumber}}",
  "orders.list.panelTitle": "Ordini",
  "orders.list.visibleCount": "{{count}} ordini visibili",
  "orders.list.paymentBadge": "Pagamento: {{status}}",
  "orders.list.openDetail": "Apri",
  "orders.list.loading": "Caricamento ordini...",
  "orders.list.found": "{{count}} ordini trovati",
  "orders.list.empty": "Nessun ordine trovato con i filtri correnti.",
  "orders.list.columns.order": "Ordine",
  "orders.list.columns.customer": "Cliente",
  "orders.list.columns.contact": "Contatto",
  "orders.list.columns.status": "Stato",
  "orders.list.columns.total": "Totale",
  "orders.list.columns.createdAt": "Creato il",
  "orders.list.customerId": "ID: {{id}}",
  "orders.details.title": "Dettaglio ordine",
  "orders.details.loading": "Caricamento dettaglio ordine...",
  "orders.details.notFound": "Ordine non trovato: {{orderId}}",
  "orders.details.selectOrder": "Seleziona un ordine dalla tabella.",
  "orders.details.fields.number": "Numero:",
  "orders.details.fields.customer": "Cliente:",
  "orders.details.fields.email": "Email:",
  "orders.details.fields.total": "Totale:",
  "orders.details.fields.updatedAt": "Aggiornato:",
  "orders.details.fields.trackingCode": "Codice tracking:",
  "orders.details.fields.trackingUrl": "URL tracking:",
  "orders.details.statusTitle": "Stato ordine",
  "orders.details.statusCardTitle": "Gestione stato",
  "orders.details.statusCardSubtitle": "Aggiorna lo stato interno dell'ordine e conferma l'operazione.",
  "orders.details.statusCurrent": "Stato attuale: {{status}}",
  "orders.details.statusTransition": "Cambio stato: da {{from}} a {{to}}",
  "orders.details.trackingPendingChanges": "Modifiche tracking non ancora salvate",
  "orders.details.workspaceEyebrow": "Workspace operativo ordini",
  "orders.details.timelineTitle": "Timeline operativa",
  "orders.details.timelineEvents": "eventi",
  "orders.details.billingShippingTitle": "Fatturazione e spedizione",
  "orders.details.billingCardTitle": "Dati cliente",
  "orders.details.shippingCardTitle": "Dati spedizione",
  "orders.details.billingPanelTitle": "Dati fatturazione",
  "orders.details.shippingPanelTitle": "Dati spedizione",
  "orders.details.notAvailable": "Non disponibile",
  "orders.details.shippedDate": "Spedito",
  "orders.details.meta.createdAt": "Creato il",
  "orders.details.meta.updatedAt": "Aggiornato il",
  "orders.details.meta.payment": "Pagamento",
  "orders.details.meta.tracking": "Tracking",
  "orders.details.sidebarSummaryTitle": "Riepilogo ordine",
  "orders.details.quickActionsTitle": "Azioni rapide",
  "orders.details.operationalActionsTitle": "Azioni operative",
  "orders.details.supportActionsTitle": "Supporto cliente",
  "orders.details.sectionSummary": "Riepilogo ordine",
  "orders.details.sectionFulfillment": "Stato e spedizione",
  "orders.details.sectionInvoices": "Fatturazione",
  "orders.details.sectionItems": "Articoli ordine",
  "orders.details.invoicesUnavailableForCancelledOrder": "Ordine annullato: sezione fatture disattivata.",
  "orders.details.invoicesTitle": "Fatture ordine",
  "orders.details.invoicesSubtitle": "Inserisci i dati, carica il PDF e conferma l'invio in un flusso rapido.",
  "orders.details.invoiceStepData": "1. Inserisci dati",
  "orders.details.invoiceStepUpload": "2. Carica file",
  "orders.details.invoiceStepConfirm": "3. Conferma",
  "orders.details.invoiceNumberLabel": "Numero fattura",
  "orders.details.invoiceDateLabel": "Data fattura",
  "orders.details.invoiceFileLabel": "File PDF fattura",
  "orders.details.invoiceDropzoneTitle": "Trascina il PDF qui o clicca per selezionarlo",
  "orders.details.invoiceDropzoneSubtitle": "Formato supportato: PDF",
  "orders.details.invoiceNumberPlaceholder": "Numero fattura (es. INV-2026-001)",
  "orders.details.invoiceFileSelected": "File selezionato: {{fileName}}",
  "orders.details.invoiceFileEmpty": "Il PDF selezionato verrà allegato alla notifica cliente.",
  "orders.details.trackingCodePlaceholder": "Es. 1Z999AA10123456784",
  "orders.details.trackingUrlPlaceholder": "https://corriere.it/tracking/ABC123",
  "orders.details.invoicePreviewOpen": "Apri in nuova scheda",
  "orders.details.replaceLatestInvoice": "Segna come aggiornamento fattura precedente",
  "orders.details.invoicesLoading": "Caricamento fatture...",
  "orders.details.invoicesEmpty": "Non sono presenti fatture per questo ordine.",
  "orders.details.invoicesEmptyCancelled": "Nessuna fattura disponibile",
  "orders.details.invoiceVersion": "v{{version}}",
  "orders.details.invoiceCancelledBadge": "Annullata",
  "orders.details.invoiceCancelledMeta": "Annullata il {{cancelledAt}} (ID utente: {{cancelledBy}})",
  "orders.details.itemsTitle": "Righe ordine",
  "orders.details.itemsSubtitle": "Controlla quantità e importi per ogni articolo.",
  "orders.details.itemsEmpty": "Nessuna riga prodotto.",
  "orders.details.itemQty": "Qtà: {{quantity}}",
  "orders.details.itemQtyActive": "Qtà disponibile: {{quantity}}",
  "orders.details.itemQtyCancelled": "Qtà annullata: {{quantity}}",
  "orders.details.itemUnitPrice": "Prezzo unitario:",
  "orders.details.itemLineTotal": "Totale riga:",
  "orders.details.itemActiveLineTotal": "Totale residuo riga:",
  "orders.details.itemsSummary": "Righe attive {{activeCount}} / {{originalCount}} • Totale importo annullato {{cancelledTotal}}",
  "orders.details.cancelQtyInput": "Quantità da annullare",
  "orders.details.cancelReasonPlaceholder": "Motivo annullo parziale (opzionale)",
  "orders.details.itemCancellationReason": "Motivo ultimo annullo: {{reason}}",
  "orders.details.itemCancellable": "Annullabile",
  "orders.details.itemNotCancellable": "Non annullabile",
  "orders.modal.openInvoiceTitle": "Aprire la fattura?",
  "orders.modal.openInvoiceDescription": "La fattura {{invoiceNumber}} verrà aperta in una nuova scheda. Vuoi continuare?",
  "orders.modal.resendInvoiceTitle": "Reinviare notifica fattura?",
  "orders.modal.resendInvoiceDescription": "Verrà reinviata la notifica cliente per la fattura {{invoiceNumber}}. Vuoi continuare?",
  "orders.modal.cancelInvoiceTitle": "Annullare la fattura?",
  "orders.modal.cancelInvoiceDescription": "La fattura {{invoiceNumber}} non sarà più visibile al cliente. Vuoi continuare?",
  "orders.modal.restoreInvoiceTitle": "Revocare annullamento fattura?",
  "orders.modal.restoreInvoiceDescription": "La fattura {{invoiceNumber}} tornerà disponibile per il cliente. Vuoi continuare?",
  "orders.messages.loadInvoicesError": "Errore caricamento fatture ordine",
  "orders.messages.loadOrdersError": "Errore caricamento ordini",
  "orders.messages.loadOrderDetailError": "Errore caricamento dettaglio ordine",
  "orders.messages.noStatusChanges": "Nessuna modifica stato da salvare",
  "orders.messages.statusUpdated": "Stato ordine aggiornato: {{status}}",
  "orders.messages.updateStatusError": "Errore aggiornamento stato ordine",
  "orders.messages.invoiceNumberRequired": "Numero fattura obbligatorio",
  "orders.messages.invoicePdfRequired": "Seleziona il PDF della fattura",
  "orders.messages.invoiceUploadedAndNotified": "Fattura caricata e notifica inviata al cliente",
  "orders.messages.invoiceUploadError": "Errore upload fattura",
  "orders.messages.invoiceResent": "Notifica fattura reinviata",
  "orders.messages.invoiceResendError": "Errore reinvio notifica fattura",
  "orders.messages.invoiceCancelled": "Fattura annullata",
  "orders.messages.invoiceCancelError": "Errore annullamento fattura",
  "orders.messages.invoiceRestored": "Annullamento fattura revocato",
  "orders.messages.invoiceRestoreError": "Errore revoca annullamento fattura",
  "orders.messages.openInvoiceError": "Errore apertura fattura",
  "orders.messages.invoiceActionsBlockedByOrderStatus": "Ordine annullato: operazioni fattura non disponibili.",
  "orders.messages.itemCancellationSuccess": "Riga ordine annullata parzialmente",
  "orders.messages.itemCancellationError": "Errore annullamento riga ordine",
  "orders.messages.noPendingOrdersSelected": "Nessun ordine in attesa selezionato.",
  "orders.messages.selectedOrdersAlreadyCancelled": "Gli ordini selezionati sono già annullati.",
  "orders.messages.confirmBulkSetCancelled": "Impostare lo stato annullato per {{count}} ordini selezionati?",
  "orders.messages.bulkStatusUpdatedPaid": "Stato interno aggiornato a pagato per {{count}} ordini.",
  "orders.messages.bulkStatusUpdatedCancelled": "Stato interno aggiornato ad annullato per {{count}} ordini.",
  "orders.cancelLineModal.title": "Annullamento parziale riga ordine",
  "orders.cancelLineModal.subtitle": "Prodotto: {{productName}}",
  "orders.cancelLineModal.quantity": "Quantità da annullare",
  "orders.cancelLineModal.maxQuantity": "Quantità massima disponibile: {{quantity}}",
  "orders.cancelLineModal.reason": "Motivo",
  "orders.cancelLineModal.confirm": "Conferma annullamento",
  "orders.messages.trackingCodeRequired": "Inserisci il codice tracking prima di impostare lo stato spedito",
  "orders.messages.trackingUrlInvalid": "Inserisci un URL tracking valido (http/https)",
  "orders.timeline.created": "Ordine creato",
  "orders.timeline.paid": "Pagamento ricevuto",
  "orders.timeline.invoiceUploaded": "Fattura caricata",
  "orders.timeline.shipped": "Ordine spedito",
  "orders.timeline.refunded": "Rimborso registrato",
  "orders.timeline.cancelled": "Ordine annullato",
  "orders.timeline.kind.webhook": "Webhook",
  "orders.timeline.kind.payment": "Pagamento",
  "orders.timeline.kind.admin": "Admin",
  "orders.timeline.kind.config": "Configurazione",
  "orders.timeline.kind.order": "Ordine",
  "orders.timeline.kind.other": "Altro",
  "orders.timeline.actor.webhook": "Sistema webhook",
  "orders.timeline.actor.system": "Sistema",
  "orders.timeline.actor.admin": "Operatore admin",
  "orders.timeline.actor.customer": "Cliente",
  "orders.timeline.actor.unknown": "Attore sconosciuto",
  "orders.timeline.filters.actionType": "Tipo azione",
  "orders.timeline.filters.actorType": "Tipo attore",
  "orders.timeline.filters.timeWindow": "Finestra temporale",
  "orders.timeline.filters.all": "Tutti",
  "orders.timeline.filters.time.all": "Tutto il periodo",
  "orders.timeline.filters.time.24h": "Ultime 24 ore",
  "orders.timeline.filters.time.7d": "Ultimi 7 giorni",
  "orders.timeline.filters.time.30d": "Ultimi 30 giorni",
  "orders.timeline.presets.all": "Tutta attività",
  "orders.timeline.presets.payment": "Eventi pagamento",
  "orders.timeline.presets.webhook": "Eventi webhook",
  "orders.timeline.presets.admin": "Azioni manuali admin",
  "orders.timeline.presets.status": "Transizioni stato",
  "orders.timeline.hint.correlation": "Usa i badge request ID per correlare azioni checkout, webhook e admin.",
  "orders.timeline.empty.base": "Nessun evento operativo disponibile per questo ordine.",
  "orders.timeline.empty.filtered": "Nessun evento corrisponde ai filtri selezionati.",
  "orders.timeline.requestId.copy": "Copia request ID",
  "orders.timeline.requestId.copied": "Copiato",
  "orders.timeline.summary.copy": "Copia riepilogo",
  "orders.timeline.summary.copied": "Riepilogo copiato",
  "orders.timeline.metadata.expand": "Mostra metadata",
  "orders.timeline.metadata.collapse": "Nascondi metadata"
}

export default ordersMessages
